import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_TOKENS_AUTHENTICATION_HISTORY: MijnRoute = {
    path: 'authenticatie-historie',
    navigationEvent: 'toAuthenticatieHistorie',
    regex: /^\/zelf-regelen\/authenticatie-historie$/,
    webcomponent: 'mijn-tokens-authenticatie-historie-webcomponent'
};
